"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCouponValidityByCode = void 0;
/**
 * Check coupon code validity
 */
var getCouponValidityByCode = function (instance) { return function (code, config) {
    return instance.get("/catalogues/coupons/codes/".concat(code, "/valid"), config);
}; };
exports.getCouponValidityByCode = getCouponValidityByCode;
